/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

const PERMIT_ACTION_PREFIX = 'LDS_';
export const LOWERDESCHUTES_PERMIT_ID = '251980';

export const LOTTERY_AWARDED = undefined; // error in PermitRegistrationPage
export const REQUIRED_LIST_ENTRY_FIELD = undefined; // error in permitUtils

// Permit Types
export const TYPE_NONMOTOR = 'NonMotor';
export const TYPE_MOTOR = 'Motor';

// permit
export const GET_PERMIT = 'LDS_GET_PERMIT';
export const GET_PERMIT_ERROR = 'LDS_GET_PERMIT_ERROR';
export const GET_PERMIT_LOADING = 'LDS_GET_PERMIT_lOADING';
export const SET_PERMIT_TYPE = 'LDS_SET_PERMIT_TYPE';
export const SET_PERMIT_DATE = 'LDS_SET_PERMIT_DATE';
export const SET_SELECTED_DIVISION = 'LDS_SET_SELECTED_DIVISION';
export const SET_ITINERARY = 'LDS_SET_ITINERARY';
export const GET_COOPERATORS = 'LDS_GET_COOPERATORS';
export const GET_COOPERATORS_ERROR = 'LDS_GET_COOPERATORS_ERROR';
export const GET_COOPERATOR = 'LDS_GET_COOPERATOR';
export const GET_COOPERATOR_ERROR = 'LDS_GET_COOPERATOR_ERROR';
export const SET_ACTIVE_TAB = 'LDS_SET_ACTIVE_TAB';
export const SET_VALIDATION_ERROR = 'LDS_SET_VALIDATION_ERROR';
export const GET_RECAREA = 'LDS_GET_RECAREA';
export const GET_RECAREA_ERROR = 'LDS_GET_RECAREA_ERROR';
export const SET_GROUP_SIZE = 'LDS_SET_GROUP_SIZE';
export const SET_LAUNCH_POINT = 'LDS_SET_LAUNCH_POINT';
export const SET_TAKEOUT_POINT = 'LDS_SET_TAKEOUT_POINT';
export const SET_START_DATE = 'LDS_SET_START_DATE';
export const SET_END_DATE = 'LDS_SET_END_DATE';
export const GET_PERMIT_GALLERY = 'LDS_GET_PERMIT_GALLERY';

// availability
export const GET_AVAILABILITY = 'LDS_GET_AVAILABILITY';
export const GET_AVAILABILITY_ERROR = 'LDS_GET_AVAILABILITY_ERROR';
export const CLEAR_AVAILABILITIES = 'LDS_CLEAR_AVAILABILITIES';

// issuance
export const POST_ISSUANCE = 'LDS_POST_ISSUANCE';
export const SET_ISSUANCE_LOADING = 'LDS_SET_ISSUANCE_LOADING';
export const POST_ISSUANCE_ERROR = 'LDS_POST_ISSUANCE_ERROR';
export const POST_ISSUANCE_CALCULATE_FEES = 'LDS_POST_ISSUANCE_CALCULATE_FEES';
export const POST_ISSUANCE_CALCULATE_FEES_ERROR =
    'LDS_POST_ISSUANCE_CALCULATE_FEES_ERROR';
export const POST_ISSUANCE_CARTLESS = 'LDS_POST_ISSUANCE_CARTLESS';
export const POST_ISSUANCE_CARTLESS_ERROR = 'LDS_POST_ISSUANCE_CARTLESS_ERROR';
export const UPDATE_ISSUANCE = 'UPDATE_ISSUANCE';
export const UPDATE_ISSUANCE_ERROR = 'UPDATE_ISSUANCE_ERROR';
export const GET_ISSUANCE = 'LDS_GET_ISSUANCE';
export const GET_ISSUANCE_ERROR = 'LDS_GET_ISSUANCE_ERROR';
export const GET_ISSUANCE_BY_STATUS = 'LDS_GET_ISSUANCE_BY_STATUS';
export const GET_ISSUANCE_BY_STATUS_ERROR = 'LDS_GET_ISSUANCE_BY_STATUS_ERROR';
export const GET_ISSUANCE_PDF = 'LDS_GET_ISSUANCE_PDF';
export const GET_ISSUANCE_PDF_ERROR = 'LDS_GET_ISSUANCE_PDF_ERROR';
export const CANCEL_ISSUANCE = 'LDS_CANCEL_ISSUANCE';
export const CANCEL_ISSUANCE_ERROR = 'LDS_CANCEL_ISSUANCE_ERROR';
export const SAVE_FILTERS = 'LDS_SAVE_FILTERS';
export const GET_USER_ISSUANCES = 'LDS_GET_USER_ISSUANCES';
export const GET_USER_ISSUANCES_ERROR = 'LDS_GET_USER_ISSUANCES_ERROR';
export const CLEAR_FETCH_ISSUANCE_ERROR = 'CLEAR_FETCH_ISSUANCE_ERROR';

export const ISSUANCE_UPDATE_REQUIRES_PAYMENT = 'UpdateRequiresPayment';
export const ISSUANCE_UPDATE_SUCCESSFUL = 'UpdateSuccessful';
export const ISSUANCE_UPDATE_REQUIRES_REFUND = 'UpdateRequiresRefund'; // go to confirmation page / populate redux
export const ISSUANCE_UPDATE_VALIDATION_ERROR = 'ValidationError';
export const INPROGRESS_ISSUANCE_UPDATED = `${PERMIT_ACTION_PREFIX}INPROGRESS_ISSUANCE_UPDATED`;

// lottery
export const GET_LOTTERY = 'GET_LOTTERY';
export const GET_LOTTERY_ERROR = 'GET_LOTTERY_ERROR';
export const POST_LOTTERY = 'POST_LOTTERY';
export const POST_LOTTERY_ERROR = 'POST_LOTTERY_ERROR';
export const NOTIFY_LOTTERY_RESULTS = 'NOTIFY_LOTTERY_RESULTS';
export const NOTIFY_LOTTERY_RESULTS_ERROR = 'NOTIFY_LOTTERY_RESULTS_ERROR';

// campsite
export const GET_CAMPSITES = 'GET_CAMPSITES';
export const GET_CAMPSITES_ERROR = 'GET_CAMPSITES_ERROR';

// reservation detail
export const PERMIT = 'PERMIT';
export const LOTTERY = 'LOTTERY';

export const SEND_CURRENT_DATE = 'SEND_CURRENT_DATE';

export const EPOCH_MULTIPLIER = 1000;

// fee display models
export const ONE_FEE = 'OneFee';
export const ADD_ON_FEE = 'AddOnFee';

// fee calculation models
export const NO_USE_FEE = 'NoUseFee';
export const FLAT_USE_FEE = 'FlatUseFee';
export const PER_GROUP_PER_NIGHT_FEE = 'PerGroupPerNight';
export const PER_GROUP_PER_DAY_FEE = 'PerGroupPerDay';
export const PER_MEMBER_FEE = 'PerMember';
export const PER_MEMBER_PER_NIGHT_FEE = 'PerMemberPerNight';
export const PER_MEMBER_PER_DAY_FEE = 'PerMemberPerDay';
export const PER_WATERCRAFT_FEE = 'PerWatercraft';
export const PER_GROUP_PER_NIGHT_CUSTOM_RANGE_HIGH_USE_ONLY_FEE =
    'PerGroupPerNightCustomRangeHighUseOnly';

// fee types
export const RESERVATION_FEE = 'ReservationFee';
export const TOTAL_USE_FEE = 'TotalUseFee';
export const MIN_BALANCE_FEE = 'MinBalanceUseFee';
export const POS_FEE = 'POSFee';
export const TAX_FEE = 'TaxFee';

export const SKU_MON_USE_FEE = 'PERUSE251980MON';
export const SKU_TUE_USE_FEE = 'PERUSE251980TUE';
export const SKU_WED_USE_FEE = 'PERUSE251980WED';
export const SKU_THU_USE_FEE = 'PERUSE251980THU';
export const SKU_FRI_USE_FEE = 'PERUSE251980FRI';
export const SKU_SAT_USE_FEE = 'PERUSE251980SAT';
export const SKU_SUN_USE_FEE = 'PERUSE251980SUN';
export const SKU_MON_MOTOR_USE_FEE = 'PERUSE251980MONM';
export const SKU_TUE_MOTOR_USE_FEE = 'PERUSE251980TUEM';
export const SKU_WED_MOTOR_USE_FEE = 'PERUSE251980WEDM';
export const SKU_THU_MOTOR_USE_FEE = 'PERUSE251980THUM';
export const SKU_FRI_MOTOR_USE_FEE = 'PERUSE251980FRIM';
export const SKU_SAT_MOTOR_USE_FEE = 'PERUSE251980SATM';
export const SKU_SUN_MOTOR_USE_FEE = 'PERUSE251980SUNM';
export const SKU_WEEKEND_USE_FEE = 'PERMIN251980WEEKEND';
export const SKU_WEEKEND_MOTOR_USE_FEE = 'PERMIN251980WEEKENDM';
export const SKU_TX_FEE = 'PERRES251980';

export const RES_ID_DELIMITER = '__';

// cart
export const GET_CART = 'GET_CART';
export const GET_CART_ERROR = 'GET_CART_ERROR';
export const CANCEL_RESERVATION = 'CANCEL_RESERVATION';
export const CANCEL_RESERVATION_ERROR = 'CANCEL_RESERVATION_ERROR';

// issuance statuses
export const PERMIT_PRELIMINARY = 'PermitPreliminary';
export const PERMIT_IN_PROGRESS = 'PermitInProgress';
export const LOTTERY_IN_PROGRESS = 'LotteryInProgress';
export const LOTTERY_SUBMITTED = 'LotterySubmitted';
export const LOTTERY_WON = 'LotteryWon';
export const LOTTERY_WON_IN_PROGRESS = 'LotteryWonInProgress';
export const LOTTERY_LOST = 'LotteryLost';
export const LOTTERY_DECLINED = 'LotteryDeclined';
export const LOTTERY_ACCEPTED = 'LotteryAccepted';
export const LOTTERY_NO_RESPONSE = 'LotteryNoResponse';
export const PERMIT_COMPLETE = 'PermitComplete';
export const LOTTERY_AWARDED_READABLE = 'Awarded';
export const LOTTERY_AWARDED_IN_PROGRESS_READABLE = 'Awarded And Being Booked';
export const PERMIT_ISSUED = 'PermitIssued';
export const CANCELLED_NO_RELEASE = 'CancelledNoRelease';
export const PERMIT_CANCELLED_BY_USER = 'PermitCancelledByUser';
export const LOTTERY_CANCELLED = 'LotteryCancelled';
export const PERMIT_VOIDED = 'PermitVoided';
export const LOTTERY_VOIDED = 'LotteryVoided';
export const LOTTERY_REJECTED = 'LotteryRejected';

// issuance readable statuses
export const PERMIT_PRELIMINARY_READABLE = 'Preliminary';
export const PERMIT_IN_PROGRESS_READABLE = 'In Progress';
export const PERMIT_COMPLETE_READABLE = 'Reserved';
export const PERMIT_ISSUED_READABLE = 'Issued';
export const PERMIT_NO_SHOW_READABLE = 'No Show';
export const PERMIT_CANCELLED_READABLE = 'Cancelled';
export const PERMIT_VOIDED_READABLE = 'Voided';

// issuance types
export const PRIVATE = 'Private';
export const COMMERCIAL = 'Commercial';
export const ADMIN = 'Admin';

// internal validations
export const IS_LOTTERY_NAME_EMPTY = 'IsLotteryNameEmpty';
export const IS_LOTTERY_START_DATE_EMPTY = 'IsLotteryStartDateEmpty';
export const IS_LOTTERY_CLOSE_DATE_EMPTY = 'IsLotteryCloseDateEmpty';
export const IS_LOTTERY_RUN_DATE_EMPTY = 'IsLotteryRunDateEmpty';
export const IS_LOTTERY_DEADLINE_DATE_EMPTY = 'IsLotteryDeadlineDateEmpty';
export const IS_LOTTERY_INFO_DISPLAY_DATE_EMPTY = 'IsLotteryInfoDisplayDateEmpty';
export const IS_LOTTERY_NOTIFY_DATE_EMPTY = 'IsLotteryNotifyDateEmpty';
export const IS_SEASON_START_DATE_EMPTY = 'IsSeasonStartDateEmpty';
export const IS_SEASON_END_DATE_EMPTY = 'IsSeasonEndDateEmpty';

// external validations
export const IS_LAUNCH_LOCATION_EMPTY = 'IsLaunchLocationEmpty';
export const IS_TAKEOUT_LOCATION_EMPTY = 'IsTakeoutLocationEmpty';
export const IS_ISSUE_STATION_EMPTY = 'IsIssueStationEmpty';
export const IS_ENTRY_DATE_EMPTY = 'IsEntryDateEmpty';
export const IS_EXIT_DATE_EMPTY = 'IsExitDateEmpty';
export const IS_GROUP_MEMBER_EMPTY = 'IsGroupMemberEmpty';
export const IS_EQUIPMENT_EMPTY = 'IsEquipmentEmpty';
export const IS_NEED_TO_KNOW_CHECKED = 'IsNeedToKnowChecked';

// validation targets
export const ENTRY_POINT = 'entryPoint';
export const EXIT_POINT = 'exitPoint';
export const ISSUE_STATION = 'issueStation';
export const GROUP_MEMBERS = 'groupMembers';
export const WATERCRAFTS = 'watercrafts';
export const EXIT_DATE = 'exitDate';
export const LOTTERY_OPEN_DATE = 'lotteryOpenDate';
export const LOTTERY_CLOSE_DATE = 'lotteryCloseDate';
export const LOTTERY_RUN_DATE = 'lotteryRunDate';
export const LOTTERY_DEADLINE_DATE = 'lotteryDeadlineDate';
export const LOTTERY_INFO_DISPLAY_DATE = 'lotteryInfoDisplayDate';
export const LOTTERY_NOTIFY_DATE = 'lotteryNotifyDate';
export const SEASON_START_DATE = 'lotterySeasonStartDate';
export const SEASON_END_DATE = 'lotterySeasonEndDate';
export const NEED_TO_KNOW_CHECKBOX = 'needToKnowChecked';
export const DIVISION_ID = 'divisionId';
export const SELECTED_DATES = 'selectedDates';

// validation types
export const REQUIRED_BOOLEAN_FIELD = 'REQUIRED_BOOLEAN_FIELD';
export const REQUIRED_STRING_FIELD = 'REQUIRED_STRING_FIELD';
export const REQUIRED_DATE_FIELD = 'REQUIRED_DATE_FIELD';
export const REQUIRED_LIST_FIELD = 'REQUIRED_LIST_FIELD';
export const REQUIRED_NUM_FIELD = 'REQUIRED_NUM_FIELD';

export const PERMIT_REGISTRATION = 'PermitRegistration';
export const LOTTERY_REGISTRATION = 'LotteryRegistration';
export const REGISTRATION = 'Registration';

// detailed availability
export const AVAILABILITY_DAYS_TO_DISPLAY = 10;
export const AVAILABILITY_DAYS_TO_SKIP = 5;
export const AVAILABILITY_DAYS_TO_DISPLAY_MOBILE = 4;
export const AVAILABILITY_DAYS_TO_SKIP_MOBILE = 4;
export const AVAILABILITY_UNSELECTED = 'AVAILABILITY_UNSELECTED';
export const AVAILABILITY_START_MULTIDAY = 'AVAILABILITY_START_MULTIDAY';
export const AVAILABILITY_CONTINUE_MULTIDAY = 'AVAILABILITY_CONTINUE_MULTIDAY';
export const AVAILABILITY_END_MULTIDAY = 'AVAILABILITY_END_MULTIDAY';
export const AVAILABILITY_SINGLE_DAY = 'AVAILABILITY_SINGLE_DAY';

export const GROUP_AVAILABILITY_DAILY_KEY_NAME = 'ConstantQuotaUsageDaily';
export const GROUP_AVAILABILITY_KEY_NAME = 'ConstantQuotaUsageByStartDate';
export const MEMBER_AVAILABILITY_KEY_NAME = 'QuotaUsageByMember';
export const AGGREGATE_AVAILABILITY_KEY_NAME = 'AggregateQuota';
export const WATERCRAFT_AVAILABILITY_KEY_NAME = 'QuotaUsageByWatercraft';
export const MAX_STOCK_KEY_NAME = 'MaxStock';
export const FILTER_NUMERICAL = 'numerical';

// common date format strings
export const DATE_FORMAT = 'ddd, MMM D, YYYY';
export const DATE_TIME_FORMAT = 'ddd, MMM D, YYYY | hh:mmA z';
export const MONTH_DAY_YEAR_FORMAT = 'MMM Do YYYY';
export const AVAILABILITY_KEY_MAP_FORMAT = 'MM/DD/YYYY';
export const MONTH_DAY_YEAR_NUM_FORMAT = 'MM/DD/YYYY';

// sales channel types
export const ONLINE = 'ONLINE';
export const FIELD_SALES = 'FIELD_SALES';
export const CALL_CENTER = 'CALL_CENTER';

// division status enum
export const DIVISION_STATUS = {
    CLOSED: 0,
    OPEN: 1,
};

export const FINALIZE_CHECKOUT = 'FINALIZE_CHECKOUT';
export const CLEAR_ISSUANCE = 'CLEAR_ISSUANCE';

// permit types enum
export const PERMIT_TYPE_RIVER = 'PERMIT_TYPE_RIVER';
export const PERMIT_TYPE_HIKING = 'PERMIT_TYPE_HIKING';
export const PERMIT_TYPE_CAMPING = 'PERMIT_TYPE_CAMPING';
export const PERMIT_TYPE_CLIMBING = 'PERMIT_TYPE_CLIMBING';
export const PERMIT_TYPE_WILDLIFE = 'PERMIT_TYPE_WILDLIFE';
export const PERMIT_TYPE_ROADENTRY = 'PERMIT_TYPE_ROADENTRY';
export const PERMIT_TYPE_EVENT = 'PERMIT_TYPE_EVENT';
export const PERMIT_TYPE_BOAT = 'PERMIT_TYPE_BOAT';
export const PERMIT_TYPE_SNOWMOBILE = 'PERMIT_TYPE_SNOWMOBILE';
export const PERMIT_TYPE_WILDERNESS = 'PERMIT_TYPE_WILDERNESS';

// lottery preferences rules constants
export const LOTTERY_PREFERENCES_TYPE = 'LotteryPreferencesType';
export const LOTTERY_PREFERENCE_SELECTION_LIMIT = 'LotteryPreferenceSelectionLimit';

// lottery preferences enum
export const LOTTERY_PREFERENCE_TYPES = {
    DATE: 1,
    DATE_DIVISION: 2,
    DATE_DIVISION_DURATION: 3,
    DATE_DIVISION_GROUP_MIN_MAX: 4,
    DATE_DIVISION_GROUP_MAX: 5,
};

// Error Messages
export const ERROR_UNAUTHORIZED = 'You are not authorized to access this page.';
export const ERROR_DEFAULT = 'Something went wrong, please try again later.';

export const COMMERCIAL_GUIDES = [
    'Adventures Without Limits',
    'Alex Gonsiewski, LLC',
    'All Waters Angling',
    'Arrowhead River Adventures',
    'Away Outfitters',
    'A-Z River Outfitters',
    "Belozer's Whitewater Fishing Guide Service",
    'Big River Outfitters',
    "Brian Silvey's Flyfishing Guide Service",
    'Cascade Guides and Outfitters',
    'Central Oregon Canoe & Kayak Supply',
    'Central Oregon Fishing, Inc',
    'Chambers Outfitter and Guide Service',
    "Chris O'Donnell's Guide Service",
    'City of Eugene ',
    "Dave McCann's Northwest River Guides ",
    'Deep Canyon Outfitters',
    'Deschutes River Adventures',
    'Deschutes River Anglers',
    'Deschutes River Guides',
    'Deschutes Scenic Adventures',
    'Deschutes U-Boat',
    'Deschutes Whitewater Services',
    'Drake Radditz Guide Service',
    'Dylan Hartsell Outfitters',
    'eNRG Kayaking',
    'Ethan Nickel Outfitters',
    "Fin N' Fire",
    'First Light Outfitters',
    'Fisher Fly Fishing',
    'Fly & Field Outfitters',
    "Forrest Foxworthy's Guide Service",
    'Griff Marshall Outdoors',
    'Hamblin Sports',
    'Harris Anglers',
    'High Country Expeditions',
    'Imperial River Company',
    'JetBoat Fly Guides, LLC',
    'John Hazel and Company',
    'Just Add Water Flyfishing',
    'Legendary Outfitters, LLC',
    'Lewis & Clark College Outdoor Program',
    'Life Expanding Adventures Programs (LEAP)',
    'Lifelines Outdoors',
    'Little Creek Outfitters',
    'Lower Deschutes Outfitters',
    'McCoy Outdoor Outfitters, LLC',
    "Nate's Rogue Adventures",
    'Neal Burrell Fly Fishing, LLC',
    'North Fork Outfitters',
    'North Pacific Outfitters',
    'Northwest Flyfishing Outfitters',
    'Northwest River Outfitters',
    'Oregon Adventure Ministries',
    'Oregon River Experience',
    'Oregon State University - Cascades',
    'Oregon Whitewater Adventures',
    'Orion Expeditions',
    'Outfishing Adventures, LLC',
    'Ouzel Outfitters',
    'Owens Boys Deschutes Reel Adventures',
    'Pacific University Outdoor Pursuits',
    'Peak 7 Adventures',
    "R's Outdoors",
    'RaftOregon.com',
    "Renton's River Adventures",
    'River Borne Outfitters',
    'River Drifters Whitewater Tours',
    'ROW Oregon, LLC',
    'Sage Canyon',
    'Sakai Fishing and Scenic Adventures',
    'Shaka Rafting',
    'Skookum Outfitters, LLC',
    'Steelhead Outfitters',
    'Sterfly Fly Fishing, LLC',
    'Stout Creek Outfitters',
    'Sun Country Tours',
    'Taylor Made Outfitters',
    'The Fly Fishers Place',
    'The National Center for Outdoor and Adventure Education (NCOAE)',
    'The Portland Fly Shop',
    'Three Canyons Fishing Adventures',
    'Toman, LLC',
    'Travois, LLC',
    "Ty Holloway's Guide Service",
    'Water Time Outfitters',
    'Western Fishing Adventures Ltd',
    'Whitman College',
    'YD Adventures',
];
